function injectStyle (ssrContext) {
  require("!!../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-24cd131a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue")
}
var Component = require("!../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-24cd131a\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 713
// module chunks = 29